import clsx from 'clsx';
import { ContainerBase } from '@/components/landing/containers';
import { Title } from '@/components/landing/title';

export const ClaimBanner: React.FC = () => {
	return (
		<div className="relative w-full hidden md:block">
			<div
				className="absolute inset-0 z-0"
				style={{
					backgroundImage: 'url(/img/landing/bg-cases.svg)',
					backgroundPosition: 'bottom',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}
			/>

			<div
				className={clsx(
					'space-y-16 pb-12 pt-12 md:pb-28 md:pt-20 relative',
					'flex flex-col items-center w-full !px-0'
				)}
			>
				<ContainerBase>
					<Title description="See if You Qualify in Less than 5 minutes - no upfront costs">
						Start Your <span className="text-primary">Claim</span> Today
					</Title>
				</ContainerBase>
			</div>
		</div>
	);
};
